import { render, staticRenderFns } from "./ColorChangeActivationType.vue?vue&type=template&id=16e60fae&"
import script from "./ColorChangeActivationType.vue?vue&type=script&lang=js&"
export * from "./ColorChangeActivationType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports